/** Day/Night mode toggle */
import { getCookie, setCookie } from './cookie'

function switchPrismTheme(isDark: boolean): void {
  const light = document.getElementById('prism-light') as HTMLLinkElement | null
  const dark = document.getElementById('prism-dark') as HTMLLinkElement | null
  if (light && dark) {
    light.disabled = isDark
    dark.disabled = !isDark
  }
}

function setThemeIcons(isNight: boolean): void {
  const day = document.querySelector('#mode-toggle .icon-day')
  const night = document.querySelector('#mode-toggle .icon-night')
  day?.classList.toggle('active', !isNight)
  night?.classList.toggle('active', isNight)
}

function applyTheme(isNight: boolean): void {
  document.body.classList.toggle('night-mode', isNight)
  switchPrismTheme(isNight)
  setThemeIcons(isNight)
}

function changeMode(): void {
  const isNight = !document.body.classList.contains('night-mode')
  setCookie('mode', isNight ? 'night' : 'day', 30)
  applyTheme(isNight)

  const disqus = document.getElementById('disqus_thread')
  if (disqus && typeof (window as any).DISQUS !== 'undefined') {
    ;(window as any).DISQUS.reset({ reload: true })
  }
}

export function initThemeToggle(): void {
  const mode = getCookie('mode')
  const nmSwitch = document.getElementById('nm-switch') as HTMLInputElement | null

  let isNight = mode === 'night'
  if (nmSwitch?.value === 'true' && mode === '') {
    const hour = new Date().getHours()
    if (hour <= 6 || hour >= 18) {
      isNight = true
      setCookie('mode', 'night', 30)
    }
  }

  applyTheme(isNight)

  document.getElementById('mode-toggle')?.addEventListener('click', changeMode)
}
